export default "__VITE_ASSET__8144b687__"